<iim-card [header]="shippingAddressHeader" [footer]="footer">
  <ng-template #shippingAddressHeader>
    <div class="px-2">
      <div class="row">
        <div class="col">
          <h3>
            <em class="fas fa-map-marked-alt pe-2"></em>
            {{ 'Lieferadresse' | translate }}
          </h3>
        </div>
      </div>
    </div>
  </ng-template>
  <div class="px-3">
    <div class="row align-items-center">
      @if (companyAddress) {
        <div class="col">
          <company-address
            [companyAddress]="companyAddress.companyAddress"
            [personName]="companyAddress.personName"
          ></company-address>
        </div>
      }
    </div>
  </div>
  <ng-template #footer>
    @if (!readonly) {
      <div class="col px-0">
        <div class="row justify-content-end mx-auto">
          <div class="col-auto px-0">
            <button
              class="btn btn-outline-dark"
              [title]="'bearbeiten' | translate"
              (click)="openAddressSelection()"
              >
              <em class="fas fa-pen"></em>
              {{ 'Bearbeiten' | translate }}
            </button>
          </div>
        </div>
      </div>
    }
  </ng-template>
</iim-card>
